import { useEffect, useState, useCallback, memo } from 'react'
import StepperAccordian from '../../../NewUiComponent/StepperAccordian/StepperAccordian'
import { setButtonLoader, setModalHeaderFooter } from '../../../ReduxTool/Slice/CommonReducers/CommonReducers'
import { setFormProjectSetup, setProject3dAnalysisIframeURL } from '../../../ReduxTool/Slice/Consumer/ConsumerReducers'
import { useAppDispatch, useAppSelector } from '../../../ReduxTool/store/hooks'
import { INSTALLATION_MODE, RoofType } from '../../../Utils/Const'
import SiteDetails from './SiteDetails/SiteDetails'
import { ApprovelPayment } from './ApprovelPayment/ApprovelPayment'
import InstallationTracking from './InstallationTracking/InstallationTracking'
import { ArrowRightIcon, BackBoxIcon } from '../../../assests/icons/Icons'
import { setInformationModalById } from '../../../ReduxTool/Slice/Map/MapReducer'
import { switchView } from '../../../lib/Customer/SwitchMap'
import globalLayers from '../../../Utils/CustomerMaps/Maps/GlobaLMap'
import { fetchBuildingfromCoordinates } from '../../../Utils/Fetch3D/fetchRoof'
import { EPCRoofAnalysisURLString } from '../../../Utils/baseUrls'
import Toast from '../../../Components/ErrorBoundry/Toast'
import { ProjectTy } from '../../../ReduxTool/Slice/Auth/types'
import { Button } from '../../../Components/Button'
import { set3dpayment } from '../../../ReduxTool/Slice/Payment/paymentReducer'

export type accordType = 'Project Summary' | 'Proceed' | 'Quick Plant Analysis' | "Site Details"

interface AccordionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children?: React.ReactNode;
  maxh?: string;
  height?: string;
  key?: string;
  isDisable?: boolean;
  isDisableClick?: () => void;
 
  overflowY?: boolean | React.CSSProperties["overflow"];
  parentOverflowY?: React.CSSProperties["overflow"];
  childrenOverflowY?: React.CSSProperties["overflowY"];
 
  activeColor?: string;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

function getActiveClasses(): string {
  return [
    " border-[color-mix(in_srgb,var(--accordion-active-color)_45%,transparent)] ",
    " shadow-[0_0_0_3px_color-mix(in_srgb,var(--accordion-active-color)_18%,transparent)] ",
  ].join(" ");
}

export const Accordion = memo(({ title, isOpen, onToggle,activeColor, children,childrenPaddingYOff, maxh,key,height,isDisable = false,isDisableClick,overflowY = true,parentOverflowY = "hidden",childrenOverflowY = "scroll" }: 
    { title: string; maxh?: string;activeColor?:boolean,childrenPaddingYOff?: boolean, isOpen: boolean; onToggle: () => void; children?: React.ReactNode;key?:string,height?:string,isDisable?:boolean,overflowY?:boolean | React.CSSProperties['overflow'],parentOverflowY?: React.CSSProperties['overflow'],childrenOverflowY?: React.CSSProperties['overflowY'],isDisableClick?: ()=>void }) => {
    return (
      <div key={key}  className={` border rounded-lg mb-1  bg-white 
      ${activeColor && getActiveClasses() } `}
       onClick={() => {if (isDisable && isDisableClick)isDisableClick() }} style={{overflow: parentOverflowY}} >
       <button onClick={(e) => {e.stopPropagation();onToggle()}} disabled={isDisable}
        className={`flex w-full items-center justify-between p-3 text-12-roboto hover:bg-gray-50 transition-colors 
          ${isDisable ? 'pointer-events-none opacity-60' : ''}`} >
          {title}
          <span className={`transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}>
            {/* <IconChevronDown className="w-4 h-4" /> */}
            <ArrowRightIcon className={`transition-transform duration-200   `} />
          </span>
        </button>

        {/* Content wrapper with conditional rendering */}
        {isOpen && children && (
          <div className={`p-3 ${childrenPaddingYOff ? " py-0 " : ""} border-t border-gray-100 animate-fadeIn !max-h-${maxh} !h-${height} ${maxh ? " scrollbar-hide" : ""} ${overflowY ? "overflow-y-scroll " : "" } `  }  style={{  maxHeight: maxh ?? "max-content",height:height ?? maxh, overflowY: childrenOverflowY}}  >
            {children}
          </div> 
        )}
      </div>
    );
  });

function NewSiteAnalyze() {
    const dispatch = useAppDispatch();
    
    // Optimized selectors to prevent unnecessary re-renders
    const selected_project = useAppSelector(state => state.consumerReducers.roofAnalysis.selected_project);
    const projectSetup = useAppSelector(state => state.consumerReducers.roofAnalysis.formDetails.projectSetup);
    const is3ddata = useAppSelector(state => state.mapref.is3ddata);
    const buttonLoader = useAppSelector(state => state.commonReducers.buttonLoader);
    const {is3dpayment} =  useAppSelector(state=>state.payment)
    const [analysisConfirm,setAnalysisConfirm] = useState(false);
    const [isAnalysis,setIsAnalysis] = useState(false);
    const { user } = useAppSelector(state => state.auth);

    const [openAccordion, setOpenAccordion] = useState<string | null>("roofspec");

    // Reset button loader on mount
    useEffect(() => {
        // dispatch(setButtonLoader(""))
    }, [dispatch]);

    // Handle 3D data logic
    useEffect(() => {
        if (is3ddata) {
            if (projectSetup?.projecttype === null || projectSetup?.projecttype?.label !== "Hybrid") {
                dispatch(setFormProjectSetup({  ...projectSetup, projecttype: { label: 'Hybrid', value: 'Hybrid' } as RoofType, useablearea: projectSetup?.totalroofarea }));
            }
        }
    }, [is3ddata, projectSetup, dispatch]);

    const handleOpenAccord = useCallback((name: string) => {
        if (name === 'quickplantanalysis' && !selected_project?.projectid) {
            return;
        }
        setOpenAccordion(prev => (prev === name ? null : name));
    }, [selected_project?.projectid]);

    const [show, hide] = useState(false)

    const fetchIframeAnalysis = async () => {
              setIsAnalysis(true)
              if (show) {
                  await switchView(globalLayers.activeView)
                  return
              }
              const building = await fetchBuildingfromCoordinates(selected_project?.lat as number, selected_project?.lng as number, selected_project?.graphicLayer);
              if (building) {
                  const token = localStorage.getItem("token");
                  // const url = `/Consumer/RoofAnalysis?token=&userid=${user.userid}&projectid=${(selected_project as ProjectTy)?.buildingid}`;
                   const url = `${EPCRoofAnalysisURLString}/Consumer/RoofAnalysis?token=${token}&userid=${user.userid}&projectid=${(selected_project as ProjectTy)?.buildingid}`;
                  dispatch(setProject3dAnalysisIframeURL(url))
                  // window.open(url, '_blank');
              } else {
                  Toast({ messageText: 'No, 3D roof availabe here', messageType: 'W', toastId: '3d-fecth', autoClose: 3500 })
              }
              setIsAnalysis(false)
              setAnalysisConfirm(false)
              return
          }

    // Change installationmode from self mode to pvNxt
    
          const handleChangeInstallationMode = () => {
          dispatch(setModalHeaderFooter({ title: "Change your installation option", btnTxt: "", secondaryBtnTxt: "", modalid: "installationmodetopvnxt",isheader:true }));
          }

           const handleOpenConfirm = () => {
            // debugger
               dispatch(setButtonLoader("loading3d"))
               if (is3dpayment != true) {
                   dispatch(setModalHeaderFooter({ title: "Upgrade to 3D Roof Analysis", btnTxt: "Proceed To Payment", secondaryBtnTxt: "Cancel",isheader:true }));
                   setAnalysisConfirm(true)
                //    dispatch(set3dpayment(true))
               } else {
                   fetchIframeAnalysis()
               }
           }

    // Memoize toggle handlers to prevent re-creation on every render
    const toggleRoofSpec = useCallback(() => handleOpenAccord('roofspec'), [handleOpenAccord]);
    const toggleProjectSetup = useCallback(() => handleOpenAccord('projectsetup'), [handleOpenAccord]);
    const toggleQuickPlantAnalysis = useCallback(() => handleOpenAccord('quickplantanalysis'), [handleOpenAccord]);
    const approvalDisableClick = useCallback(() =>{ dispatch(setInformationModalById({id:"leadprocessepc"}))},[selected_project?.isepccomplete])

    const installationModeChange = selected_project?.installationmode as INSTALLATION_MODE === "Self Mode" && !selected_project?.project_generation_id;
    const outlineButton = is3ddata ?  <Button className="primary-outline-btn md-btn" name={"3D View"} onClick={()=>handleOpenConfirm()} isLoading={buttonLoader === "loading3d"} disabled={false || (selected_project?.consumer_subprojectstatus ?? 0) < 3}  /> : null;
      
    return (
        <div className='p-1'>
            <StepperAccordian disabled={false} subHeader={"Measure & confirm your solar potential"} stepNumber={1} status={selected_project === null || (selected_project?.consumer_mainprojectstatus ?? 0) < 1 ? "current" : "completed"} 
                isLoading={false} accType='tertiary' isHeaderFixed stepHeight='56vh' open={openAccordion === 'roofspec'} accordianName='1 Your Roof Details' onToggle={toggleRoofSpec} headName={"Your Roof Details"} onPrimaryBtnClick={undefined}
                onPrimaryBtnClick2={installationModeChange ? handleChangeInstallationMode : undefined}  primaryBtn2Name="Change Installation Option"       
                outlinBtnProp={outlineButton} primaryBtn2LeftIcon={<BackBoxIcon rotate90 />} flexDirectionFootterPropsBtn={"column"}    >
                <div className='w-full py-2'>
                    <SiteDetails />
                </div>
            </StepperAccordian>
            <StepperAccordian onDisableClick={(selected_project?.consumer_mainprojectstatus ?? 0 ) >= 1 && (selected_project?.proposalfilepath ?? "") ==="" ? approvalDisableClick : undefined} subHeader={"Review final plan, sign agreement, make payment"} stepNumber={2} disabled={selected_project?.proposalfilepath === "" || !selected_project} status={(selected_project?.consumer_mainprojectstatus ?? 0) < 1 ? "upcoming" : (selected_project?.consumer_mainprojectstatus ?? 0) === 1 ? "current" : "completed"} 
                accType='tertiary' isHeaderFixed stepMinHeight='20vh' stepHeight='57vh' open={openAccordion === 'projectsetup'} accordianName='2 Approval & Payment' onToggle={toggleProjectSetup} headName={"Approval & Payment"} 
                primaryBtnName='' onPrimaryBtnClick={undefined}  >
                <div className='my-2'>
                    <ApprovelPayment />
                </div>
            </StepperAccordian>

            <StepperAccordian subHeader={"See work progress on your site"} stepNumber={3} status={(selected_project?.consumer_mainprojectstatus ?? 0) < 2 ? "upcoming" : (selected_project?.consumer_mainprojectstatus ?? 0) === 2 ? "current" : "completed"} 
                disabled={(selected_project?.consumer_mainprojectstatus ?? 0) < 2} accLastIdx='1' stepMinHeight='20vh' stepHeight='100%' stepMaxHeight='60vh' isLoading={buttonLoader === "loading3d"} accType='tertiary'
                isHeaderFixed open={openAccordion === 'quickplantanalysis'} accordianName='2 Installation Tracking' onToggle={toggleQuickPlantAnalysis} outBtnName={undefined} headName={"Installation Tracking"}  onPrimaryBtnClick={undefined}
                 >
                {/* onDisableClick={!selected_project?.isepccomplete ? trackingDisableClick : undefined} > */}
                <InstallationTracking />
            </StepperAccordian>
        </div>
    )
}
export default memo(NewSiteAnalyze)




// import { memo, useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { toast } from 'react-toastify'
// import Toast from '../../../Components/ErrorBoundry/Toast'
// import NewStepperAccordian from '../../../Components/NewUIComponent/NewStepperAccordian'
// import { btnTitleTypeCustomer } from '../../../Containers/DefaultLayouts/AsideRouteLists'
// import { switchView } from '../../../lib/Customer/SwitchMap'
// import { setUserProjects } from '../../../ReduxTool/Slice/Auth/AuthReducer'
// import { ProjectTy } from '../../../ReduxTool/Slice/Auth/types'
// import { setButtonLoader, setModalHeaderFooter } from '../../../ReduxTool/Slice/CommonReducers/CommonReducers'
// import { fetchPANOND } from '../../../ReduxTool/Slice/Consumer/ConsumerActions'
// import { resetRoofAnalisis, setFormProjectSetup, setOndFiles, setProject3dAnalysisIframeURL, setRoofDetailsError } from '../../../ReduxTool/Slice/Consumer/ConsumerReducers'
// import { saveConsumerProjects } from '../../../ReduxTool/Slice/Consumer/ProjectServices/projectServices'
// import { setCardTitle } from '../../../ReduxTool/Slice/Dashboard/DashboardReducer'
// import { setTitle, toggleDrawer } from '../../../ReduxTool/Slice/Drawer/DrawerReducer'
// import { toogleTooltip } from '../../../ReduxTool/Slice/Map/MapReducer'
// import { useAppDispatch, useAppSelector } from '../../../ReduxTool/store/hooks'
// import { EPCRoofAnalysisURLString } from '../../../Utils/baseUrls'
// import { coverageFactor, defaultmoduleLength, defaultmoduleWidth, FORMTOASTERRID, MAXUSEABLEAREA, MINUSEABLEAREA, RoofType, voltagepermodule } from '../../../Utils/Const'
// import globalLayers from '../../../Utils/CustomerMaps/Maps/GlobaLMap'
// import { fetchBuildingfromCoordinates } from '../../../Utils/Fetch3D/fetchRoof'
// import CustomerProjectSetup, { computeCapacity } from './ConsumerProjectSetup/CustomerProjectSetup'
// import QuickPlantAnalysis from './QuickPlantAnalysis/QuickPlantAnalysis'
// import RoofSpec from './RoofSpec/RoofSpec'
// import { set3dpayment } from '../../../ReduxTool/Slice/Payment/paymentReducer'
// import { validatePincode } from '../../../Utils/commonFunctions'
// import StepperAccordian from '../../../NewUiComponent/StepperAccordian/StepperAccordian'
// import { AccountIcon, ArrowRightIcon, EditIcon, InfoMark, LocationIcon } from '../../../assests/icons/Icons'
// import { Button } from '../../../Components/Button'
// import { IconSave } from '../../../assests/icons/MapToolsIcons'
// import RoofDetails from './RoofDetails/RoofDetails'
// import SiteDetails from './SiteDetails/SiteDetails'
// import { ApprovelPayment } from './ApprovelPayment/ApprovelPayment'
// import InstallationTracking from './InstallationTracking/InstallationTracking'

// export type accordType = 'Project Summary' | 'Proceed' | 'Quick Plant Analysis' | "Site Details"

// export const Accordion = memo(({ title, isOpen, onToggle, children, maxh,key,height,disable = false}: { title: string; maxh?: string; isOpen: boolean; onToggle: () => void; children?: React.ReactNode;key?:string,height?:string,disable?:boolean }) => {
//     return (
//       <div key={key}  className="border rounded-lg mb-3 overflow-hidden bg-white" >
//        <button onClick={onToggle} disabled={disable} className="flex w-full items-center justify-between p-3 text-sm text-[12px] text-[rgba(97,97,97,1)] hover:bg-gray-50 transition-colors" >
//           {title}
//           <span className={`transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}>
//             {/* <IconChevronDown className="w-4 h-4" /> */}
//             <ArrowRightIcon className={`transition-transform duration-200   `} />
//           </span>
//         </button>

//         {/* Content wrapper with conditional rendering */}
//         {isOpen && children && (
//           <div className={`p-3 border-t border-gray-100 animate-fadeIn !max-h-${maxh} !h-${height} ${maxh ? "overflow-y-scroll scrollbar-hide" : ""}`  }  style={{  maxHeight: maxh ?? "max-content",height:height ?? maxh }}  >
//             {children}
//           </div> 
//         )}
//       </div>
//     );
//   });

// function NewSiteAnalyze() {
//     const dispatch = useAppDispatch(), navigate = useNavigate();
//     const { roofAnalysis: { subsequentOption, selectedOption, formDetails: { projectSetup, quickplantAnalysis, projectSummary, error }, isWithRoof, selected_project }, projects, ondFiles } = useAppSelector(state => state.consumerReducers);
//     const {is3dpayment} =  useAppSelector(state=>state.payment)
//     const {is3ddata } = useAppSelector(state => state.mapref);
//     const { allDiscom, modal: { title: modalTitle },buttonLoader } = useAppSelector(state => state.commonReducers);
//     const [isConfimModal, setIsConfimModal] = useState(false);
//     const { user } = useAppSelector(state => state.auth);
//     const [openAccordion, setOpenAccordion] = useState<string | null>("roofspec");
//     const [isLoading, setIsLoading] = useState<boolean>(false);
//     const [siteAnalysisFailMsg, setSiteAnalysisFailMsg] = useState(false)
//     const [qpaIsLoading, setQPAIsLoading] = useState<boolean>(false);
//     const [analysisConfirm,setAnalysisConfirm] = useState(false);
//     const [isAnalysis,setIsAnalysis] = useState(false);

//     useEffect(()=>{
//      dispatch(setButtonLoader(""))
//     },[])

//     useEffect(()=>{
//           if (is3ddata) {
//             //    if(projectSetup?.projecttype === null || projectSetup?.projecttype?.label !== "Hybrid") {dispatch(setFormProjectSetup({ ...projectSetup, projecttype: { label: 'Hybrid', value: 'Hybrid' } as RoofType,useablearea : projectSetup?.totalroofarea}))}
//                if(projectSetup?.projecttype === null || projectSetup?.projecttype?.label !== "Hybrid") {dispatch(setFormProjectSetup({ ...projectSetup, projecttype: { label: 'Hybrid', value: 'Hybrid' } as RoofType,useablearea : projectSetup?.totalroofarea}))}
//               }
//       },[is3ddata,projectSetup?.projecttype])

//     const saveProjectDetails = async (projectid?: string) => {
//         setQPAIsLoading(true)
//         try {
//             let reqBody = {
//                 projectname: projectSetup.projectname,
//                 projecttype: projectSetup.projecttype?.value,
//                 address: projectSetup.address,
//                 userid: user.userid,
//                 sanctionload: projectSetup.sanctionload,
//                 // electricityrate: +currencyConverter(user.country_mstr, projectSetup.electricityrate, true, true),
//                 electricityrate: +projectSetup.electricityrate,
//                 useablearea: projectSetup.useablearea,
//                 lat: projectSetup.lat,
//                 lng: projectSetup.lng,
//                 totalroofarea: projectSetup.totalroofarea,
//                 providerid: projectSetup.providerid?.value,
//                 consumercategoryid: projectSetup.consumercategoryid?.value,
//                 graphicLayer: isWithRoof ? JSON.stringify(globalLayers.selectedGraphic) : "",
//                 plantcapacity: projectSetup?.plantcapacity ?? 0,
//                 monthlyunit: projectSetup.monthlyunit ? Number(projectSetup.monthlyunit) : 0 as number,
//                 // usable area not working from globallayer
//                 //  plantCap = Math.round((useablearea * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000))
//                 // maxplantcapacity: projectSetup?.plantcapacity === 0 ? Math.round(((selected_project?.useablearea ?? 0) * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000)) ?? 0 : projectSetup?.plantcapacity ?? 0,
//                 maxplantcapacity: projectSetup?.plantcapacity,
//                 createdby: user.userid,
//                 consumerdetails: {},
//                 // consumer_projectstatus: selected_project?.consumer_projectstatus === 0 ? selected_project?.consumer_projectstatus + 1 : selected_project?.consumer_projectstatus ?? 0,
//                 //  consumer_subprojectstatus: selected_project?.consumer_subprojectstatus === 0 ? 1 : selected_project?.consumer_subprojectstatus ?? 1,
//                 consumer_subprojectstatus: selected_project?.consumer_subprojectstatus === 1 ? 2 : selected_project?.consumer_subprojectstatus,
//                 projectlocation: {
//                     // houseblock: projectSetup.houseblock,roadarea:projectSetup.roadarea,
//                    address:projectSetup.addressline1,
//                    city:projectSetup.city,state:projectSetup.state,country:projectSetup.country,
//                    pincode:projectSetup.pincode
//                }
//             };
//             // const { inverter, module } = await fetchPANOND();
//             // dispatch(setOndFiles({ inverter, module }));
//             // usable area not working from globallayer
//             // reqBody.plantcapacity = Math.round((reqBody?.usablearea * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000));
//             // reqBody.plantcapacity = Math.round((reqBody?.useablearea * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000));
//             reqBody.plantcapacity = reqBody?.plantcapacity;
//             reqBody.maxplantcapacity = reqBody.plantcapacity;
//             globalLayers.plantcapacity = reqBody.plantcapacity;
//             globalLayers.isSavedProject = true;
//             const consumerDetails = selected_project?.consumerdetails && typeof selected_project.consumerdetails === 'string' ? JSON.parse(selected_project.consumerdetails) : selected_project?.consumerdetails || {};
//             if (selected_project && selected_project.consumerdetails) {
//                 reqBody.consumerdetails = JSON.stringify({
//                     ...consumerDetails,
//                     ...reqBody,
//                 });
//             } else {
//                 reqBody.consumerdetails = JSON.stringify(reqBody);
//             }

//             const { payload }: any = await dispatch(saveConsumerProjects({ reqBody, projectid }));
//             if (typeof payload === "string") {
//                 throw new Error("Something went wrong to save or update projects")
//             }
//             if (payload) {
//                 if (payload.code && payload.code !== "200") {
//                     toast.error(payload.response?.data.message ?? payload.message, { toastId: "customID",autoClose: 7000 });
//                     return;
//                 };
//                 globalLayers.selected_project = payload
//                 toast.success(`The project setup has been successfully ${projectid ? "updated" : "saved"}`, { toastId: "customID",autoClose: 7000 });

//                 if (!projectid) {
//                     let projects: ProjectTy[] = []
//                     if (user.projects?.length) {
//                         projects = [...user.projects!, payload]
//                     } else {
//                         projects = [payload];
//                     }
//                     dispatch(setUserProjects(projects));
//                 }

//                 sessionStorage.setItem("projectid", payload.projectid);
//                 //nextModal
//                 if (openAccordion === "roofspec") { 
//                     // setOpenAccordion(null);
//                     setOpenAccordion("projectsetup")
//                  } else if (openAccordion === "projectsetup") {
//                     setOpenAccordion("quickplantanalysis")
//                 }

//             }
//         } catch (err) {
//             console.log(err);
//         } finally {
//             setQPAIsLoading(false)
//         }
//         globalLayers.stopSketch()
//     };

//     const validateForm = (): boolean => {
//         let isValid = true;
//         const errors: Record<string, string> = {};
//         const isProjectNameExists = projects?.some((ele: any) => ele.projectname === projectSetup.projectname);
//         const computedCapacity = computeCapacity((projectSetup?.useablearea || 0 > 0) ? +projectSetup?.useablearea?.toFixed(2) : +projectSetup?.totalroofarea?.toFixed(2))
//         const maxComputedCapacity = computeCapacity((projectSetup?.useablearea || 0 > 0) ? +projectSetup?.useablearea?.toFixed(2) : +projectSetup?.totalroofarea?.toFixed(2))
//         if (projectSetup?.sanctionload > computedCapacity) {
//             toast.error(`Max AC Load should be less than max plant capacity ${computedCapacity?? ""} `, { toastId: "customID",autoClose: 7000 });
//             return false
//         }
//         const validateSanctionload = ()=>{
//             if (!projectSetup.sanctionload) {       }
//             if (projectSetup?.sanctionload > computedCapacity) {       }
//         }
//         const validations = [
//             { field: "address", condition: !projectSetup.address, message: "This field is required" },
//             { field: "totalroofarea", condition: !projectSetup.totalroofarea, message: "This field is required" },
//             // { field: "roadarea", condition: !projectSetup.roadarea, message: "This field is required" },
//             // { field: "houseblock", condition: !projectSetup.houseblock, message: "This field is required" },
//             { field: "addressline1", condition: !projectSetup.addressline1, message: "This field is required" },
//             // { field: "state", condition: !projectSetup.state, message: "This field is required" },
//             { field: "city", condition: !projectSetup.city, message: "This field is required" },
//             // { field: "country", condition: !projectSetup.country, message: "This field is required" },
//             { field: "pincode", condition: !projectSetup.pincode, message: "This field is required" },
//             {
//                 field: "totalroofarea", condition: projectSetup.totalroofarea !== undefined && (projectSetup.totalroofarea < MINUSEABLEAREA || projectSetup.totalroofarea > MAXUSEABLEAREA), message: `Total roof area must be between ${MINUSEABLEAREA} to ${MAXUSEABLEAREA} sq m`
//             },
//             { field: "projectname", condition: !projectSetup.projectname, message: "This field is required" },
//             { field: "projecttype", condition: !projectSetup.projecttype || !projectSetup?.projecttype?.label, message: "This field is required" },
//             { field: "sanctionload", condition: !projectSetup.sanctionload, message: "This field is required" }
//         ];
//         if (allDiscom.length > 0) {
//             validations.push(
//                 { field: "providerid", condition: !projectSetup.providerid?.value, message: "This field is required" },
//                 { field: "consumercategoryid", condition: !projectSetup.consumercategoryid?.value, message: "This field is required" }
//             );
//         };
//         for (const { field, condition, message } of validations) {
//             if (condition) {
//                 errors[field] = message;
//                 isValid = false;
//             }
//         }
        
//         if (Object.keys(errors).length > 0) {
//             dispatch(setRoofDetailsError(errors));
//         };
//         // debugger
//        if (Object.keys(error).length > 0) {
//          const updatedError = { ...error };
//         //  debugger
//          if (updatedError.sanctionload && projectSetup?.sanctionload <= computedCapacity  &&  updatedError.sanctionload.endsWith("roof area.")) {
//              delete updatedError.sanctionload;
//          }
//          dispatch(setRoofDetailsError(updatedError));
//          if (Object.keys(updatedError).length > 0) {
//              isValid = false;
//              Toast({messageText: "Information is missing or incorrect. Please update and try again.",messageType: "E",autoClose: 3000,toastId: FORMTOASTERRID});
//          }
//           }
//         return isValid;
//     };

//     const validateSiteDetails = (): boolean => {
//         let isValid = true;
//         const errors: Record<string, string> = {};
//         const isProjectNameExists = projects?.some((ele: any) => ele.projectname === projectSetup.projectname);

           
//       const countryName = user?.country_mstr?.countryname || "";
//     //   const installationMode = selectedProject[0]?.installationmode;
//       let pincodeValidation = validatePincode(projectSetup.pincode,countryName);
//       if (!projectSetup.pincode) {
//         pincodeValidation = {...pincodeValidation,error:"This field is required"}
//       }
//         const validations = [
//             { field: "address", condition: !projectSetup.address, message: "This field is required" },
//             { field: "addressline1", condition: !projectSetup.addressline1, message: "This field is required" },
//             { field: "city", condition: !projectSetup.city, message: "This field is required" },
//             { field: "state", condition: !projectSetup.state, message: "This field is required" },
//             // { field: "pincode", condition: !projectSetup.pincode, message: "This field is required" },
//             { field: "pincode", condition: !pincodeValidation.isValid, message: pincodeValidation.error?? "This field is required" },
//         ];
//         // if (allDiscom.length > 0) {
//         //     validations.push(
//         //         { field: "providerid", condition: !projectSetup.providerid?.value, message: "This field is required" },
//         //         { field: "consumercategoryid", condition: !projectSetup.consumercategoryid?.value, message: "This field is required" }
//         //     );
//         // };
//         for (const { field, condition, message } of validations) {
//             if (condition) {
//                 errors[field] = message;
//                 isValid = false;
//             }
//         }
//         if (Object.keys(errors).length > 0) {
//             dispatch(setRoofDetailsError(errors));
//         };
//         if (Object.keys(error).length > 0) {
//             isValid = false;
//             Toast({ messageText: "Information is missing or incorrect. Please update and try again.", messageType: "E", autoClose: 3000, toastId: FORMTOASTERRID })
//         }
//         return isValid;
//     };

//     const handleFooterNxtBtn = async (btnTitle: btnTitleTypeCustomer) => {
//         // debugger
//         dispatch(toogleTooltip({ dipy: 0, istooltip: "", msg: "" }))
//         switch (btnTitle) {
//             case "Site Details":{

//                 if ((selected_project && selected_project.iscompleted === false) || selected_project === null) {
//                     validateSiteDetails() && saveProjectDetails(selected_project?.projectid ?? "");
//                     // dispatch(setTitle("quickplantanalysis"))
//                     // setOpenAccordion("quickplantanalysis")
//                 } else {
//                     const { inverter, module } = await fetchPANOND();
//                     const { payload } = dispatch(setOndFiles({ inverter, module }));
//                     if (payload) {
//                         //nextModal
//                         setOpenAccordion("projectsetup")
//                     }
//                 }
//                 break
//             }

//             case "Quick Plant Analysis": {  
//                 if ((selected_project && selected_project.iscompleted === false) || selected_project === null) {
//                     validateForm() && saveProjectDetails(selected_project?.projectid ?? "");
//                     // dispatch(setTitle("quickplantanalysis"))
//                     // setOpenAccordion("quickplantanalysis")
//                 } else {
//                     const { inverter, module } = await fetchPANOND();
//                     const { payload } = dispatch(setOndFiles({ inverter, module }));
//                     if (payload) {
//                         //nextModal
//                         setOpenAccordion("quickplantanalysis")
//                     }
//                 }
//                 break;
//             }
//             case "Project Summary": {
//                 if (selected_project?.installationmode) {
//                     toast.info("An order has already been placed for this project.", { toastId: "",autoClose: 7000 });
//                     // toast.info("You have already placed an order for this existing Project.", { toastId: "" })
//                     return;
//                 };
//                 dispatch(setModalHeaderFooter({ title: "Confirm The Action", btnTxt: "Proceed", secondaryBtnTxt: "" }));
//                 setIsConfimModal(true);
//                 break;
//             };
//             case "Proceed": {
//                 if (selected_project?.installationmode) {
//                     toast.info("An order has already been placed for this project.", { toastId: "",autoClose: 7000 });
//                     // toast.info("You have already placed an order for this existing Project.", { toastId: "" })
//                     navigate("/Consumer");

//                     return;
//                 };
//                 // validateForm() && saveProjectDetails(selected_project?.projectid ?? "");
//                 dispatch(setModalHeaderFooter({ title: "Confirm The Action", btnTxt: "Proceed", secondaryBtnTxt: "",modalid:"finalproject" }));
//                 setIsConfimModal(true);
//                 // console.log('Proceed called::==>> ')
//                 break;
//             };
//         };
//     };

//     const handleOpenAccord = (name: string) => {
//         // console.log('Project id not present in quickplant ==>>>', selected_project?.projectid)
//         if (name === 'quickplantanalysis' && !selected_project?.projectid) {
//             // toast.error('Project id not present in quickplant ', { toastId: "customID" })

//             return; // Do nothing
//         }
//         // debugger
//         setOpenAccordion(prev => (prev === name ? null : name));
//     };

//     const handleSiteAnalysisPrceed = () => {
//         if (!siteAnalysisFailMsg) {
//             // handleFooterNxtBtn("Proceed")
//         } else {
//             toast.error("Unable to load data. Please reload the page and try again.",{autoClose: 7000});
//         }
//     }

//     const [show, hide] = useState(false)

//     const fetchIframeAnalysis = async () => {
//         setIsAnalysis(true)
//         if (show) {
//             await switchView(globalLayers.activeView)
//             return
//         }
//         const building = await fetchBuildingfromCoordinates(selected_project?.lat as number, selected_project?.lng as number);
//         if (building) {
//             const token = localStorage.getItem("token");
//             const url = `${EPCRoofAnalysisURLString}/Consumer/RoofAnalysis?token=${token}&userid=${user.userid}&projectid=${(selected_project as ProjectTy)?.buildingid}`;
//             dispatch(setProject3dAnalysisIframeURL(url))
//             // window.open(url, '_blank');
//         } else {
//             Toast({ messageText: 'No, 3D roof availabe here', messageType: 'W', toastId: '3d-fecth', autoClose: 3500 })
//         }
//         setIsAnalysis(false)
//         setAnalysisConfirm(false)
//         return
//     }

//     const handleCloseConfirm =  ()=>{
//         dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "" }));
//         setAnalysisConfirm(false)
//     }

//     const handleOpenConfirm = () => {
//         dispatch(setButtonLoader("loading3d"))
//         if (is3dpayment != true) {
//             dispatch(setModalHeaderFooter({ title: "Upgrade to 3D Roof Analysis", btnTxt: "Proceed To Payment", secondaryBtnTxt: "Cancel" }));
//             setAnalysisConfirm(true)
//             // dispatch(set3dpayment(true))
//         } else {
//             fetchIframeAnalysis()
//         }
//     }

//     return (
//         <>
        
//         <div className='pt-4'>
//             {/* {isConfimModal && <NewModal name={"Big sun, big savings"} btnName={"Button Name"} onClick={handleModalClick} isAbleCLick={true} children={<ConfirmAction />} setIsCLose={setIsConfimModal} />} */}
//             {/* {analysisConfirm && <NewModal name={"Subscribe 3D    Design"} isLoading={isAnalysis} modalSize='lg' btnName={"Pay"} onClick={fetchIframeAnalysis} isAbleCLick={true} children={<><p>Pay to get access to 3D roof analysis.</p></>} setIsCLose={handleCloseConfirm} />} */}

           
//             <StepperAccordian disabled={false} subHeader={"Measure & confirm your solar potential"} stepNumber={1} 
//              status={selected_project === null || selected_project?.consumer_mainprojectstatus! < 1 ? "current" : "completed"} isLoading={qpaIsLoading} accType='tertiary' isHeaderFixed stepHeight='56vh' open={openAccordion === 'roofspec'} accordianName='1 Your Roof Details' onToggle={() => handleOpenAccord('roofspec')} headName={"Your Roof Details"} onPrimaryBtnClick={undefined} >
//                 {/* <RoofSpec setIsLoading={setQPAIsLoading} isLoading={qpaIsLoading} /> */}
//                 <div className='w-full py-2'>
//                <SiteDetails />
//                 </div>
//             </StepperAccordian>
            
//             <StepperAccordian subHeader={"Review final plan, sign agreement, make payment"} stepNumber={2} 
//              disabled={!selected_project?.consumer_mainprojectstatus && (selected_project?.consumer_mainprojectstatus ?? 0) < 1} status={(selected_project?.consumer_mainprojectstatus ?? 0) < 1 ? "upcoming" : (selected_project?.consumer_mainprojectstatus ?? 0) === 1 ? "current" : "completed"} accType='tertiary' isHeaderFixed  stepMinHeight='20vh' /* stepHeight='69vh' */ 
//              stepHeight='57vh' open={openAccordion === 'projectsetup'} accordianName='2 Approval & Payment' onToggle={() => handleOpenAccord('projectsetup')} headName={"Approval & Payment"} primaryBtnName='' onPrimaryBtnClick={undefined}  >
//                 {/* <CustomerProjectSetup setIsLoading={setQPAIsLoading} isLoading={qpaIsLoading} /> */}
//                 <>
//                 <div className='my-2'>
//                 <ApprovelPayment />
//                 </div>
//                 </>
//             </StepperAccordian>

//             <StepperAccordian subHeader={"See work progress on your site"} stepNumber={3} status={(selected_project?.consumer_mainprojectstatus ?? 0) < 2 ? "upcoming" : (selected_project?.consumer_mainprojectstatus ?? 0) === 2 ? "current" : "completed"} disabled={(selected_project?.consumer_mainprojectstatus || 0) < 2}
//              accLastIdx='1' stepMinHeight='20vh' stepHeight='100%' stepMaxHeight='60vh' isLoading={isLoading || buttonLoader === "loading3d"} accType='tertiary'
//              isHeaderFixed open={openAccordion === 'quickplantanalysis'} accordianName='2 Installation Tracking'
//              onToggle={() => handleOpenAccord('quickplantanalysis')} outBtnName={undefined} 
//              onOutlineClick={is3ddata?()=>undefined:undefined} headName={"Installation Tracking"}  onPrimaryBtnClick={undefined} >
//              {/* onOutlineClick={is3ddata?()=>handleOpenConfirm():undefined} headName={"Installation Tracking"}  onPrimaryBtnClick={undefined} > */}
//              {/* onOutlineClick={is3ddata?()=>handleOpenConfirm():undefined} headName={"Site Analysis"} primaryBtnName='Proceed' onPrimaryBtnClick={handleSiteAnalysisPrceed} > */}
//                {/* {openAccordion === 'quickplantanalysis'  ? <QuickPlantAnalysis setIsLoading={setIsLoading} setSiteAnalysisFailMsg={setSiteAnalysisFailMsg} isLoading={isLoading} />:<></>} */}
//                <>
//                <InstallationTracking />
//                </>
//                </StepperAccordian>
//               </div>
//               </>
//     )
// }
// export default NewSiteAnalyze
